// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation files (JSON) for different languages
const resources = {
  en: {
    translation: {
      loginTitle: 'Online Order System',
      footer: 'Online Ordering System. All Rights Reserved.',
      reminder: 'Note: The cut-off time for orders is {{time}} on the day before the delivery date (the cut-off time for Monday delivery is {{time}} on the previous Saturday)',
      loading: 'Loading...',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      orderManagement: 'Order Management',
      customerManagement: 'Customer Management',
      userManagement: 'User Management',
      orderInformation: 'Order Information',
      personalInfo: 'Personal Info.',
      logout: 'Logout',
      customer: 'Customer',
      selectCustomer: 'Select Customer',
      deliveryDate: 'Delivery Date',
      placeOrder: 'Place An Order',
      orderList: 'Order List',
      productList: 'Product List',
      searchProduct: 'Search Product...',
      skipOrder: 'Skip this order',
      searchCustomer: 'Search Customer...',
      noselectedCustomer: 'Please select a customer first!',
      sales: 'Sales',
      replace: 'Replace',
      sample: 'Sample',
      cancel: 'Cancel',
      submitting: 'Submitting...',
      submitOrder: 'Submit',
      orderItem: 'Order Item',
      totalQty: 'Total Quantity',
      pieces: ' PC',
      image: 'Image',
      description: 'Description',
      translationType: 'Type',
      qty: 'Quantity',
      back: 'Back',
      confirmSubmit: 'Confirm',
      noTickConfirm: 'Tick Agree',

      cancelled: 'Cancelled',
      Processing: 'Processing',
      completed: 'Completed',
      created: 'Created',
      unknown: 'Unknown',
      refresh: 'Refresh',
      search: 'Search',
      startDate: 'Start Date',
      endDate: 'End Date',
      customerNo: 'Customer No.',
      enterCustomer: 'Enter customer No.',
      noOrderFound: 'No Order Record Found',
      clear: 'Clear',
      orderNo: 'Order#',
      orderStatus: 'Status',
      backToList: 'Back',
      deleteOrder: 'Delete',
      editOrder: 'Edit',
      store: 'Store',
      createDate: 'Create Date',
      lineItem: 'Line Items',
      product: 'Product',
      noOrderInfo: 'Order information not found',
      order: 'Order',
      loadCustErr: 'Failed to load Customer',
      loadDateErr: 'Failed to load delivery date',

      contactUs: 'CONTACT US',
      companyAddress: 'COMPANY ADDRESS',
      addressInfo: 'Kowloon Dairy Building, 17–19 On Lan Street, Central, Hong Kong',
      ft_office: 'OFFICE',
      office_tel: 'Tel: +852 2526 4055',
      office_fax: 'Fax: +852 2868 4142',
      ft_order: 'ORDERING (Retail & Catering Clients)',
      order_tel: 'Tel: +852 2466 1188',
      order_fax: 'Fax: +852 2467 6201',
      terms_and_conditions: 'Terms and Conditions',
      agree_tc: 'I have read and agree to the relevant',
      need_ic: 'IC replenishment(Check this box if needed; the ice cream truck will visit the store as soon as the next delivery cycle)',
      
      tac1: 'PAYMENT',
      tac1_1: 'The purchaser shall make payment of the products to the supplier according to the payment term stated in the invoice.',
      tac1_2: 'If payment is not received by the supplier on or before the due date(s), the supplier shall be entitled to:-',
      tac1_2a: 'charge interest on all outstanding amount(s) at the rate of 2% per annum above the Hong Kong dollar prime lending rate determined by the Hongkong and Shanghai Banking Corporation Limited, accruing on a daily basis until the date of actual payment; and',
      tac1_2b: 'put on hold all or any of the remaining delivery to the purchaser, its subsidiary and/or franchisee.',

      tac2: 'DELIVERY',
      tac2_1: 'The supplier shall not be liable for any loss or damage incurred or suffered by the purchaser and/or its subsidiary and/or franchisee as a result of late delivery of the products.',
      tac2_2: 'The supplier shall under no circumstances be liable for any loss (whether direct or indirect) of revenue, loss of profits or any indirect or consequential loss whatsoever suffered, sustained or incurred by the purchaser or by other person arising (directly or indirectly) from or out of or relating to these terms and conditions or from delay or failure to perform any or all of these terms and conditions where such delay or failure shall be due to causes beyond its control without limitation to war, riots, acts of God, restraints imposed by governments or any other industrial or trade disputes, fires, explosions, storms, floods, lightening, earthquakes and other natural calamities.',
      tac2_3: 'The risk in the products shall pass to the purchaser on delivery.',
      tac2_4: 'The title in the products shall not pass to the purchaser until the supplier has received the payment of the price (and any other sums that are due or owning to the supplier) in full, whether or not delivery has been made.',
      
      tac3: 'ASSIGNMENT',
      tac3_1: 'The purchaser shall not assign, transfer or otherwise any of its rights and obligations under these terms and conditions to any third party without the prior written consent of the supplier.',
      
      tac4: 'WAIVER',
      tac4_1: 'No failure or delay by the supplier in exercising any right, power or privilege under these terms and conditions shall impair the same or operate as a waiver of the same nor shall any single or partial exercise of any rights, power or privilege preclude any further exercise of the same or the exercise of any other right, power or privilege. The rights and remedies provided in these terms and conditions are cumulative and not exclusive of any rights and remedies provided by law.',
      
      tac5: 'SEVERABILITY',
      tac5_1: 'If any of these terms and conditions herein is deemed invalid or unenforceable by a court of competent jurisdiction, such invalidity or unenforceability shall not affect or limit the validity or enforceability of any other terms and conditions hereof.',
      
      tac6: 'GOVERNING LAW AND JURISDICTION',
      tac6_1: 'These terms and conditions shall be governed and interpreted in all respects by the law of Hong Kong Special Administrative Region. Each party shall submit to the exclusive jurisdiction of the Hong Kong Court in the determination of any dispute arising hereunder.',
      
      tac7: 'LANGUAGE',
      tac7_1: 'The English version shall prevail in case of any discrepancy or inconsistency between the English version and its Chinese translation.',
      
      msg_invalidUser: 'Invalid ID',
      msg_inactiveUser: 'Inactive User',
      msg_wrongPassword: 'Wrong Password',
      msg_orderExist: 'Order with the same delivery date have already been submitted',
      msg_tmrCut: "The order time for tomorrow's delivery has ended",
      msg_noItem: 'Please add at least one product',
      msg_noDate: 'Please select a delivery date',
      msg_wrongDate: 'Please reload the page to get the correct delivery date',
      msg_noCustomer: 'Please select a customer',
      msg_orderCreateSuccess: 'Order created successfully',
      msg_orderCreateFail: 'Failed to create order',
      msg_tryLater: 'Please try again later',
      msg_loadItemFail: 'Failed to load product',
      msg_loadconfigFail: 'Failed to shared config',
      msg_product: 'Product',
      msg_invalidNS: 'order quantity is invalid',
      msg_invalidRP: 'replace quantity is invalid',
      msg_invalidSA: 'sample quantity is invalid',
      msg_orderChanged: 'The order status has been updated, please refresh the page',
      msg_deleteSuccess: 'The order has been deleted. You will be redirected to the order list in 3 seconds.',
      msg_deleteFailed: 'Order deletion failed',
      msg_confirmDelete: 'Are you sure you want to delete the order?',
      msg_noStartDate: 'Please input a start date',
      msg_noEndDate: 'Please input a end date',
      msg_updateSuccess: 'Order updated successfully',
      msg_updateFailed: 'Update order failed',
      msg_loadOrderFailed: 'Failed to load order details',
      msg_checkOrderExistFail: 'Failed to check for duplicate orders',
      yes: 'Confirm',
    },
  },
  zh: {
    translation: {
      loginTitle: 'Online Order System',
      footer: '線上訂購系統。版權所有。',
      reminder: '注意: 截單時間是預計送貨日前一天的{{time}} (週一送貨截單時間是上週六{{time}})',
      loading: '載入中...',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日',
      orderManagement: '訂單管理',
      customerManagement: '客戶管理',
      userManagement: '用戶管理',
      personalInfo: '個人資料',
      logout: '登出',
      deliveryDate: '送貨日期',
      orderInformation: '訂單資訊',
      customer: '客戶',
      selectCustomer: '選擇客戶',
      placeOrder: '落訂單',
      orderList: '訂單列表',
      productList:'產品列表',
      searchProduct: '搜尋產品...',
      skipOrder: '跳過本次訂單',
      searchCustomer: '搜尋客戶...',
      noselectedCustomer: '請先選擇客戶!',
      sales: '訂購',
      replace: '換貨',
      sample: '樣品',
      cancel: '取消',
      submitting: '提交中...',
      submitOrder: '提交',
      orderItem: '訂單產品',
      totalQty: '總數量',
      pieces: '件',
      image: '圖片',
      description: '描述',
      translationType: '類型',
      qty: '數量',
      back: '返回',
      confirmSubmit: '確定提交',
      noTickConfirm: '先勾選同意',

      cancelled: '已取消',
      Processing: '處理中',
      completed: '已完成',
      created: '已建立',
      unknown: '未知',
      refresh: '刷新',
      search: '搜尋',
      startDate: '起始日期',
      endDate: '結束日期',
      customerNo: '客戶編號',
      enterCustomer: '輸入客戶編號',
      clear: '清除',
      noOrderFound: '沒有找到訂單記錄',
      orderNo: '訂單#',
      orderStatus: '狀態',
      backToList: '返回列表',
      deleteOrder: '删除',
      editOrder: '更改',
      store: '店鋪',
      createDate: '訂單日期',
      lineItem: '訂單項目',
      product: '產品',
      noOrderInfo: '找不到訂單資訊',
      order: '訂單',
      loadCustErr: '加載客戶失敗',
      loadDateErr: '加載送貨日期失敗',

      contactUs: '聯絡我們',
      companyAddress: '公司地址',
      addressInfo: '香港中環安蘭街 17-19 號維記大廈',
      ft_office: '寫字樓',
      office_tel: '電話: +852 2526 4055',
      office_fax: '傳真: +852 2868 4142',
      ft_order: '訂貨 (零售及餐飲業務客戶)',
      order_tel: '電話: +852 2466 1188',
      order_fax: '傳真: +852 2467 6201',
      terms_and_conditions: '條款及細則',
      tac1: '貨款支付',
      tac1_1: '採購商應依照發票上註明的付款期限向供貨商支付貨款。',
      tac1_2: '若供貨商在到期日或到期日之前沒有收到貨款，供貨商有權:-',
      tac1_2a: '就所有欠款收取利息，利率按香港上海匯豐銀行有限公司所釐定的港元最優惠貸款利率加 2% 的年利率，按日計息，直至實際付款日為止; 及',
      tac1_2b: '暫停向採購商、子公司及/或特許經營商交付全部或任何剩餘貨品。',
      tac2: '交貨',
      tac2_1: '對於採購商及/或其子公司及/或特許經營商因延遲交付貨品而產生或遭受的任何損失或損害，供貨商概不負責。',
      tac2_2: '在任何情況下，對於因為(一)本條款及條件、(二)與本條款及條件有關的原因、或(三)履行本條款及條件時(由於超出供貨商可控制的範圍，不限於戰爭、暴動、天災、政府限制或任何其他工業或貿易糾紛、火災、爆炸、風暴、洪水、雷電、地震和其他自然災害等)造成的延遲或失誤，而導致採購商或他人遭受、承受或招致的任何(直接或間接)收入損失、利潤損失或任何間接或後果性損失，供貨商概不負責。',
      tac2_3: '產品風險於供貨商交貨時轉移給採購商。',
      tac2_4: '無論供貨商是否已經交貨，供貨商擁有貨品的所有權直至採購商付清全額貨款(以及任何其他應付或拖欠供貨商的款項)。',
      tac3: '轉讓',
      tac3_1: '未經供貨商事先書面同意，採購商不得向任何第三方轉讓、轉移或以其他方式承擔本條款及條件所規定的任何權利和義務。',
      tac4: '寬免',
      tac4_1: '供貨商未行使或延遲行使本條款及條件所規定的任何權利、權力或特權，均不損害該權利、權力或特權，也不構成對該權利、權力或特權的放棄，而且任何一次或部分行使這些權利、權力或特權，均不妨礙進一步行使該權利、權力或特權，或任何其他權利、權力或特權。這些條款及條件中所規定的權利及補救措施並不具有排他性。',
      tac5: '分割',
      tac5_1: '如果管轄權的法院認為本協議中的任何條款或條件無效或不可執行，其他條款及條件的有效性或可執行性不會受其影響或限制。',
      tac6: '法律及管轄權',
      tac6_1: '本條款及條件受香港特別行政區法律所管轄，並作出釋義。各方應服從香港法院的專屬管轄權，以裁定因本協議而產生的任何爭議。',
      tac7: '語言',
      tac7_1: '若英文版本與中文譯本有任何不一致之處，應以英文版本為準。',
      agree_tc: '我已經閱讀並同意相關的',
      need_ic: '雪糕補貨(如需要，請勾選此框，雪糕車最快會在下一個車期到店)',

      msg_invalidUser: '無效的用戶名稱',
      msg_inactiveUser: '此帳號已被停用',
      msg_wrongPassword: '密碼錯誤',
      msg_orderExist: '相同送貨日期的訂單已提交',
      msg_tmrCut: '明天送貨的下單時間已經截止',
      msg_noItem: '請添加至少一件產品',
      msg_noDate: '請選擇送貨日期',
      msg_wrongDate: '請重新加載頁面以獲取正確的送貨日期',
      msg_noCustomer: '請選擇客戶',
      msg_orderCreateSuccess: '訂單創建成功',
      msg_orderCreateFail: '創建訂單失敗',
      msg_tryLater: '請稍後再試',
      msg_loadItemFail: '載入產品失敗',
      msg_loadconfigFail: '載入配置失敗',
      msg_product: '產品',
      msg_invalidNS: '的訂購數量無效',
      msg_invalidRP: '的換貨數量無效',
      msg_invalidSA: '的樣品數量無效',
      msg_orderChanged: '訂單狀態已更新，請刷新頁面',
      msg_deleteSuccess: '訂單已删除，3秒後將跳轉至訂單列表',
      msg_deleteFailed: '訂單删除失敗',
      msg_confirmDelete: '確定删除訂單?',
      msg_noStartDate: '請輸入開始日期',
      msg_noEndDate: '請輸入結束日期',
      msg_updateSuccess: '訂單已成功更新',
      msg_updateFailed: '更新訂單失敗',
      msg_loadOrderFailed: '載入訂單詳情失敗',
      msg_checkOrderExistFail: '未能檢查重覆訂單',
      yes: '確定',
    },
  },
};

i18n
  .use(initReactI18next) // Bind react-i18next to i18next
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language if translation is missing
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;